
const FIXED_TIME = 15
export default {
  data () {
    return {
      // 导出参数配置:
      exportZipObj: {
        isExport: 1,
        contextmenuWrap: [],
        sort: {},
        search: {}
      },
      computedTime: FIXED_TIME
    }
  },
  methods: {
    batchExportZip (listName) {
      this.exportZipObj['contextmenuWrap'] = listName['tableQuery']['contextmenuWrap']
      this.exportZipObj['search'] = listName['tableQuery']['search']
      this.exportZipObj['sort'] = listName['tableQuery']['sort']
      if (this.computedTime === FIXED_TIME) {
        this.setExportZipByPage()
        this.$message({
          dangerouslyUseHTMLString: true,
          type: 'success',
          message: `<strong>${this.$t('operation.tips_export')}</strong>`,
          duration: 5000,
          offset: 80
        })
      } else {
        this.$message({ message: this.$t('messageTip.operateRepeat'), type: 'warning' })
      }
    },
    setExportZipByPage () {
      this.ExportZipByPage()
      this.timer = setInterval(() => {
        this.computedTime--
        if (this.computedTime === 0) {
          clearInterval(this.timer)
          this.computedTime = FIXED_TIME
        }
      }, 1000)
    }
  }
}
